import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/**
 * The shared bordered/rounded surface for markdown editors — docs, notes, and
 * the duty cards. Pass `className` to extend it (e.g. the full-height panel
 * layout in EditorPanelShell).
 *
 * No `overflow-hidden` here on purpose: Crepe's heading dropdown opens
 * downward (`position: absolute; top: 100%`) and a short editor would clip it.
 * Consumers that need clipping (the panel shell, for its floating action bar)
 * opt in via `className`.
 *
 * The hairline is a `ring` (outset box-shadow), not a `border`: it sits outside
 * the box and follows the radius, so children (the sticky toolbar) can round to
 * the same 12px and tile the corners perfectly — a real border sits 1px in and
 * leaves a hollow corner once the box stops clipping.
 */
export function MarkdownEditorContainer({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div
      className={cn(
        'rounded-xl bg-app shadow-sm ring-1 ring-border',
        className
      )}>
      {children}
    </div>
  )
}
